/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { HousingDetailsSchema } from './HousingDetails.schema';
import { AddressSchema } from './Address.schema';
const baseSchema = z.object({
    housingDetails: z.lazy(() => HousingDetailsSchema).nullish(),
    address: z.lazy(() => AddressSchema).nullish(),
}
).strict();
export const ListingDetailsSchema = baseSchema;
